export const DoubleFormat= number => parseFloat(number)?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })